module.exports = __webpack_public_path__ + "static/media/1643512711525771.e7574c72.mp4";